import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "アメリカン・フットボール",
    Baseball: "野球",
    Basketball: "バスケットボール",
    Boxing: "ボクシング",
    Chess: "チェス",
    Cricket: "クリケット",
    Darts: "ダーツ",
    Entertainment: "エンターテイメント",
    "E-Sports": "e-スポーツ",
    Football: "サッカー",
    "Formula 1": "Ｆ１",
    "Gaelic Football": "ゲーリックフットボール",
    "Generic Sport": "ジェネリックスポーツ",
    Golf: "ゴルフ",
    "Greyhound Racing": "グレイハウンド",
    Handball: "ハンドボール",
    "Ice Hockey": "アイス・ホッケー",
    IndyCar: "インディアカ",
    MMA: "総合格闘技",
    Nascar: "NASCAR",
    Politics: "ポリティクス",
    "Rugby League": "ラグビーリーグ",
    "Rugby Union": "ラグビーユニオン",
    Snooker: "スヌーカー",
    "Table Tennis": "卓球",
    Tennis: "テニス",
    "Virtual Football": "バーチャル・フットボール",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} 勝利",
    WinFirstRound: "{name} 1stラウンドで勝利",
    FirstTouchdown: "{name} が先にタッチダウンで先制点",
    FirstTry: "{name} が先にトライで先制点",
    TotalGoals: "{name} 合計ゴール数",
    TotalRuns: "{name} 合計ラン数",
    TotalPoints: "{name} 合計ポイント",
    TopBatsman: "{name} がトップバットマン",
    TopBowler: "{name} がトップボウラー",
    FirstScore: "{name} が先制点"
  },
  PromoTexts: {
    Pick: "選択してください",
    Bet: "ベット",
    Pays: "支払い"
  },
  DateTimeTexts: {
    Today: "今日",
    Tomorrow: "明日",
    Live: "ライブ"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "選択してください",
    Return: "支払い",
    Stake: "ベット",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "試合につき",
    H2H: "H2H",
    W: "W",
    D: "D",
    L: "L",
    T: "T",

    // soccer
    goals_scored: "得点",
    shots: "シュート",
    shots_on_target: "枠内シュート",
    ball_possession: "ボール保持",
    goals_conceded: "失点",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
